import React from 'react';
import '../../components/CancelPopup/CancelPopup.css';
import CrossIcon from "../../assets/images/cross.svg";
import WarningIcon from "../../assets/images/warning.svg";

const ConfirmationPopup = ({ title, message, warningText, onClose, onConfirm }) => {
  return (
    <div className="popup-container" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="top">
          <h2 className="popup-title">{title || "Confirmation"}</h2>
        </div>
        <img src={CrossIcon} className="close-button" onClick={onClose} alt="Close" />
        {warningText && (
          <div className="warning-box">
            <img src={WarningIcon} className="warning-icon" alt="Warning" />
            <p className="warning-text">{warningText}</p>
          </div>
        )}
        <p className="popup-message">{message}</p>
        <div className="popup-actions">
          <button className="go-back-btn" onClick={onClose}>No</button>
          <button className="confirm-btn" onClick={onConfirm}>Yes</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopup;
